import {ICoordinates} from './ICoordinates';
import {ILocation} from './ILocation';
import {IObjectMap} from './IObjectMap';

export enum CheckinStatus {
  reserved = 'reserved',
  waiting = 'waiting',
  active = 'active',
  finished = 'finished',
  virtual = 'virtual',
  rejected = 'rejected'
}

export enum CheckinType {
  registration = 'registration',
  ticket = 'ticket',
}

export interface ICheckinParticipants {
  id: string;
  name: string;
  isAdded: boolean;
  avatarUrl: string;
}

export interface ICheckin {
  id: string;
  chatId: string;
  location: ILocation;
  visitorId: string;
  visitor: string;
  visitorPosition: ICoordinates;
  visitorsCount: number;
  languages?: string[];
  pin: string;
  status: CheckinStatus;
  requestedAt: string;
  acceptedAt?: string;
  checkedOutAt?: string;
  queuedAt?: string;
  rejectReason?: string;
  rejectedAt?: string;
  expiresAt?: string;
  type?: CheckinType;
  dequeueRequest?: any[];
  presenceRequests?: IPresenceRequest[];
  chatEnabled?: boolean;
  chatStarted?: boolean;
  waitingPosition?: number;
  waitingTime?: number;
  reservationId?: string;
  fields?: IObjectMap<any>;
}

export interface IPresenceRequest {
  confirmedAt?: string;
  extendWith: number;
  requestedAt: string;
}
